<template>
  <div class="form__fieldset">
    <h3 class="form__title">{{ in18['attribute_shipping_method'] }}</h3>
    <div class="row mb-4">
      <div v-for="shippingMethod in shippingMethods" class="col-md-6 mb-4">
        <div :class="{ 'disabled': inProgress }" class="radio-btn">
          <input
              :id="shippingMethod.code"
              v-model="selectedShippingMethod"
              :disabled="inProgress"
              :value="shippingMethod"
              class="radio-btn__input"
              name="shipping"
              type="radio"
              @change="selectShippingMethod()"
          >
          <label :for="shippingMethod.code" class="radio-btn__label">
            <picture>
              <source :srcset="shippingMethod.image.webp" type="image/webp">
              <img :alt="shippingMethod.title" :src="shippingMethod.image.source" class="radio-btn__icon">
            </picture>
            <div class="radio-btn__title">{{ shippingMethod.title }}</div>
            <div class="radio-btn__text">{{ shippingMethod.description }}</div>
          </label>
        </div>
      </div>
      <validation-error :errors="errors['shipping_method']"/>
    </div>
    <!-- Render the selected shipping component if available -->
    <div v-if="selectedShippingComponent">
      <component
          :in-progress="inProgress"
          :is="selectedShippingComponent"
          :key="selectedShippingMethod.code"
          :errors="errors"
          :in18="in18"
          :shipping="shipping"
          :shipping-method="selectedShippingMethod"
          @update-cart="updateCart"
          @update-error="updateError"
          @country-selected="selectShippingMethod"
      />
    </div>
  </div>
</template>

<script>
import ValidationError from '../../features/ValidationError.vue';
import Courier from '../checkout/shipping/Courier.vue';
import Locker from '../checkout/shipping/Locker.vue';
import Shop from '../checkout/shipping/Shop.vue';

export default {

  name: "CheckoutShipping",

  components: {
    'validation-error': ValidationError,
    'courier':          Courier,
    'locker':           Locker,
    'shop':             Shop,
  },

  props: {
    in18:       {
      type: Object,
    },
    shipping:   {
      type: Object,
    },
    errors:     {
      type: Object,
    },
    cart:       {
      type: Object,
    },
    inProgress: {
      type: Boolean,
    },
  },

  emits: [
    'update-cart',
    'update-error',
    'update-shipping-method',
    'update-in-progress',
    'update-payment-method',
  ],

  data() {
    return {
      shippingMethods:        [],            // Stores available shipping methods
      selectedShippingMethod: null,   // Stores the selected shipping method
    };
  },

  created() {
    this.fetchShippingMethods();
  },

  computed: {
    selectedShippingComponent() {
      if (this.selectedShippingMethod) {
        // Return the shipping component based on the selected shipping method type
        return this.selectedShippingMethod.type;
      }
      return null;
    },
  },

  methods: {

    updateCart(cart) {
      this.$emit('update-cart', cart);
    },

    updateError(key, value) {
      this.$emit('update-error', key, value);
    },

    fetchShippingMethods() {
      axios.get('/api/shipping')
          .then((response) => {
            this.shippingMethods = response.data.shippingMethods;
          })
          .catch((error) => {
            console.error('Error fetching shipping methods:', error);
          })
          .finally(() => {
            this.selectedShippingMethod = this.cart.shipping_method ? this.cart.shipping_method : null;
          })
    },

    selectShippingMethod() {

      if (this.inProgress) {
        return;
      }

      // Notify the parent component about the progress update
      this.$emit('update-in-progress', true);
      this.$emit('update-shipping-method', null);

      // Clear shipping details
      this.shipping.identifier = null;
      this.shipping.region_id = null;
      this.shipping.area_id = null;
      this.shipping.city = '';
      this.shipping.village = '';
      this.shipping.building_num = '';
      this.shipping.house_num = '';
      this.shipping.address = '';
      this.shipping.zip = '';

      return axios.post('/api/cart/shipping/' + this.selectedShippingMethod.id, this.shipping)
          .then((response) => {
            // Emit events to update the cart and selected shipping method
            this.$emit('update-cart', response.data.cart);
            this.$emit('update-shipping-method', this.selectedShippingMethod);
            ga_add_shipping_info_event(response.data.cart);
          })
          .catch((error) => {
            window.toastr.error(error.response.data.message);
          });
    },
  }
};
</script>
